import Vue from "vue";
import Vuex from "vuex";

import invoice from "./invoice.module";
import checkout from "./checkout.module";
import merchant from "./merchant.module";
import general from "./general.module";

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		invoice,
		checkout,
		merchant,
		general
	}
});
